export const sampleInspector = {
  name: 'Vanessa',
  carsInspected: 15,
  ranking: 5,
}

export const samplePercentage = {
  percentage: '80',
}
